<template>
<div>
  <filter-help
      @removeAllSmallParts="$emit('removeAllSmallParts')"
      @removeTheHull="$emit('removeTheHull')"
  />
  <div class="include-exclude mb-3 mt-2">
    <tile-button
        v-if="$store.getters.getExportFilterModeById(filterId)"
        ref="tiles"
        :icons="false"
        :initial-active-tiles="[$store.getters.getExportFilterModeById(filterId)]"
        :is-multi-select="false"
        :tiles="['include', 'exclude']"
        :update-mode="true"
        :values="['include', 'exclude']"
        @trigger="setActive"
    />
    <div class="lighter section-darker">All matched items will be {{ $store.getters.getExportFilterModeById(filterId) }}d</div>
  </div>
  <div class="section-darker p-2">
    <label class="vform-label white mb-0">{{ $t('Selection Groups') }} (OR)</label><br/>
    <span class="lighter">{{ $t('filter.selectionSetHint') }}</span><br/>
    <selection-set-selector
        :assembly-id="assemblyId"
        :filter-id="filterId"
        type="filter"
        class="mt-1"
    />
  </div>
  <div class="or-separator">OR</div>
  <div class="section-darker p-2 mt-2">
    <label class="vform-label white mb-0">{{ $t('stringSearch') }}</label>
    <string-filter
        :filter-id="filterId"
        type="filter"
    />
  </div>
  <div class="or-separator">OR</div>
  <div class="mt-2 section-darker p-2">
    <label class="vform-label white mb-0">{{ $t('metaSearch') }}</label>
    <meta-field-filter-2
        v-if="metaSets"
        ref="metaFieldFilter"
        :filter-id="filterId"
        :meta-sets="metaSets"
        :organization-id="organizationId"
        type="filter"
        @setMode="setActive"
    />
  </div>

</div>
</template>

<script>
import FilterHelp from "@/components/sfxFilter/FilterHelp.vue";
import TileButton from "@/components/forms/TileButton.vue";
import StringFilter from "@/components/sfxFilter/StringFilter.vue";
import MetaFieldFilter2 from "@/components/sfxFilter/MetaFieldFilter2.vue";
import SelectionSetSelector from "@/components/exportProfiles/SelectionSetSelector.vue";

export default {
  name: "FilterSection",
  components: {SelectionSetSelector, MetaFieldFilter2, StringFilter, TileButton, FilterHelp},
  props: {
    filterId: {type: String, required: true},
    organizationId: {type: String, default: ''},
    projectId: {type: String, default: ''},
    assemblyId: {type: String, default: ''},
    metaSets: {type: Array, default: () => []},
  },
  methods: {
    setActive(mode) {
      this.$emit('setMode', mode);
    }
  }
}
</script>

<style lang="scss" scoped>
.include-exclude {
  max-width: 300px;
  opacity: 0.7;
  &.lighter {
    opacity: 0.8;
  }
}
.section-darker {
  background-color: rgba(255,255,255,0.2);
  padding: 3px 5px;
  border-radius: 5px;
  margin-top: 1px
}
.or-separator {
  font-size: 0.7rem;
  text-align: center;
  font-weight: bold;
  margin-top: 10px;
  margin-left: 50%;
  transform: translateX(-50%);
  width: 50px;
  background-color: var(--vform-editor-ui-secondary-color);
  border: 1px dashed rgba(255,255,255,0.2);
  border-radius: 3px;
  opacity: 0.7;
}
</style>